import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "row no-gutters pt-45 px-sm-5 px-3" };
const _hoisted_4 = { class: "col-12" };
import eventBus from '@/services/EventBus';
import ContactForm from '@/components/Base/Forms/ContactForm.vue';
import { ref, onMounted } from 'vue';
// POPUPS wohnen in der popups.html.twig !!!!
// Button-Sample zum öffnen eines, bzw. dieses Popups:
// <open-popup-button popup-name="contactPopup"><div class="buttonBase buttonGreen">KONTAKT</div></open-popup-button>
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactPopup',
    setup(__props) {
        onMounted(() => {
            eventBus.on('openContactPopup', () => {
                openPopup.value = true;
            });
            eventBus.on('closeContactPopup', () => {
                openPopup.value = false;
            });
        });
        const openPopup = ref(false);
        return (_ctx, _cache) => {
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                class: "openContactPopup",
                modelValue: openPopup.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openPopup).value = $event)),
                width: "800",
                "max-height": "80vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-block" }, "Kontaktformular", -1)),
                                _createElementVNode("i", {
                                    onClick: ($event) => (isActive.value = false),
                                    class: "icon-cancel pointerhover float-right pr-2"
                                }, null, 8, _hoisted_2)
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(ContactForm)
                                ])
                            ])
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/components/VCard"
import { VDialog as _component_v_dialog } from "vuetify/components/VDialog"

